<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="19"
		viewBox="0 0 18 19"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5.4375 6.5C5.4375 4.53248 7.03248 2.9375 9 2.9375C10.9675 2.9375 12.5625 4.53248 12.5625 6.5C12.5625 7.66271 12.0055 8.69535 11.1437 9.34558C13.2929 10.1988 14.8125 12.2969 14.8125 14.75V15.5C14.8125 15.8107 14.5607 16.0625 14.25 16.0625C13.9393 16.0625 13.6875 15.8107 13.6875 15.5V14.75C13.6875 12.1612 11.5888 10.0625 9 10.0625C6.41117 10.0625 4.3125 12.1612 4.3125 14.75V15.5C4.3125 15.8107 4.06066 16.0625 3.75 16.0625C3.43934 16.0625 3.1875 15.8107 3.1875 15.5V14.75C3.1875 12.2969 4.7071 10.1988 6.8563 9.34558C5.99453 8.69535 5.4375 7.66271 5.4375 6.5ZM9 4.0625C7.6538 4.0625 6.5625 5.15381 6.5625 6.5C6.5625 7.84617 7.65381 8.9375 9 8.9375C10.3462 8.9375 11.4375 7.84616 11.4375 6.5C11.4375 5.15381 10.3462 4.0625 9 4.0625Z"
			fill="#E9E9E9"
		/>
	</svg>
</template>
